<script setup lang="ts">
import { FeeTarget } from '@lib/shared';

import type { SaleItemEntity, SaleListingItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: SaleItemEntity | SaleListingItemEntity;
}
const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const { data: authData } = useAuthUtils();

// DATA
const feeTarget = computed((): FeeTarget => (sale.sellerCompanyId !== authData.value?.user?.companyId ? FeeTarget.Buyer : FeeTarget.Seller));
</script>

<template>
    <p class="inline-flex gap-1 text-sm">
        <span class="text-dimmed">{{ tt(`fees.simpleNotice.${feeTarget}`) }}</span>
        <SaleFeesInfoModalButton :sale="sale" />
    </p>
</template>
